import { type ReactElement } from 'react';

import { ChatVoiceNote } from '@/shared/chat/chat-voice-note.js';

interface ChatAudioBubbleProps {
  readonly audioUrl: string;
  readonly messageId: string;
  readonly durationSeconds?: number;
  readonly inverted?: boolean;
}

/** Staff chat voice note. Same player as the WhatsApp inbox. */
export function ChatAudioBubble({
  audioUrl,
  messageId,
  durationSeconds,
  inverted = false,
}: ChatAudioBubbleProps): ReactElement {
  return (
    <ChatVoiceNote
      audioUrl={audioUrl}
      messageId={messageId}
      own={inverted}
      {...(durationSeconds !== undefined ? { durationSeconds } : {})}
    />
  );
}
